import { render, staticRenderFns } from "./PersonCertificatStep1.vue?vue&type=template&id=3b160e72&scoped=true&"
import script from "./PersonCertificatStep1.vue?vue&type=script&lang=js&"
export * from "./PersonCertificatStep1.vue?vue&type=script&lang=js&"
import style0 from "./PersonCertificatStep1.vue?vue&type=style&index=0&id=3b160e72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b160e72",
  null
  
)

export default component.exports